import { useContextSelector } from 'use-context-selector'
import { AppDatesContext } from '../../../../providers'


export default function useAppMonthSelector() {

    const monthYear = useContextSelector(AppDatesContext, ({state}) => state.monthYear)
    const setMonthYear = useContextSelector(AppDatesContext, ({updateState}) => updateState)

    return {
        monthYear, setMonthYear
    }
}